export default __webpack_public_path__ + "static/media/Donation.9a007f13.png";